
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Why Us', path: '/#why-us' },
    { name: 'Contact', path: '/#contact' },
  ];

  const handleNavClick = (path: string) => {
    setIsMobileMenuOpen(false);
    if (path.includes('#')) {
      const [route, hash] = path.split('#');
      if (location.pathname !== route && route) {
        // Fallback navigation – replace with your router's navigation method if needed
        if (typeof window.REACT_APP_NAVIGATE === 'function') {
          window.REACT_APP_NAVIGATE(route);
        } else {
          console.warn('Navigation function not available. Consider using useNavigate from react‑router.');
        }
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/44f98372b9b5340986f638f89e868d42/4c25d2aa9fdf4ef7e00c69386c4d9c94.png"
              alt="Decimal Esporte"
              className="h-20 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <div key={link.path}>
                {link.path.includes('#') ? (
                  <button
                    onClick={() => handleNavClick(link.path)}
                    className={`text-[#0A1628] font-medium hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap ${
                      location.pathname === link.path.split('#')[0] ? 'text-[#0066FF]' : ''
                    }`}
                  >
                    {link.name}
                  </button>
                ) : (
                  <Link
                    to={link.path}
                    className={`text-[#0A1628] font-medium hover:text-[#0066FF] transition-colors whitespace-nowrap ${
                      location.pathname === link.path ? 'text-[#0066FF]' : ''
                    }`}
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-[#0A1628]`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            {navLinks.map((link) => (
              <div key={link.path}>
                {link.path.includes('#') ? (
                  <button
                    onClick={() => handleNavClick(link.path)}
                    className="block w-full text-left py-3 text-[#0A1628] font-medium hover:text-[#0066FF] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </button>
                ) : (
                  <Link
                    to={link.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="block py-3 text-[#0A1628] font-medium hover:text-[#0066FF] transition-colors"
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
            <button
              onClick={() => handleNavClick('/#contact')}
              className="w-full mt-4 bg-[#0066FF] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#0052CC] transition-all cursor-pointer whitespace-nowrap"
            >
              Get Started →
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
